import { t } from "@lingui/macro";

import { WithRealSafeAreaInsets } from "@/hooks/useRealSafeAreaInsets";
import { PopUpModal } from "@whoosh/design-system/src/components/overlay/PopUpModal";
import { VStack, Text } from "@whoosh/design-system/src/components/primitive";

import { useHandleLogOutCleanUp } from "../../../features/Authentication/hooks/useHandleLogOutCleanUp";
import { useMutationWithError } from "../../../utils/hooks/useMutationWithError";
import { LogOutMutationString } from "../mutations/LogOut";

type SignoutModalProps = {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
};

const SignoutModal = ({ isOpen, setIsOpen }: SignoutModalProps) => {
  const handleLogOutCleanUp = useHandleLogOutCleanUp();
  const [tryLogOut] = useMutationWithError(LogOutMutationString);

  const signOut = () => {
    tryLogOut({
      variables: { input: {} },
      onCompleted: () => handleLogOutCleanUp(),
    });
  };

  const onConfirmationPress = () => {
    setIsOpen(false);

    void signOut();
  };

  const onCancelPress = () => {
    setIsOpen(false);
  };

  return (
    <WithRealSafeAreaInsets>
      <PopUpModal
        upperTitle={t`Sign Out`}
        content={
          <VStack>
            <Text
              maxFontSizeMultiplier={2}
              variant="mainBaseSemiBold"
              color="text-secondary"
            >
              {t`Are you sure you want to sign out?`}
            </Text>
          </VStack>
        }
        theme="danger"
        isOpen={isOpen}
        cancelText={t`Dismiss`}
        confirmText={t`Sign Out`}
        onClose={(confirm: boolean) => {
          if (confirm) {
            onConfirmationPress();
          } else {
            onCancelPress();
          }
        }}
      />
    </WithRealSafeAreaInsets>
  );
};

export default SignoutModal;
